import { Component, OnInit, Input } from '@angular/core';
import { ItemDetails } from '../../_models/item/item-details.model';
import { Global } from 'src/app/globals';
import { ItemSearchType } from 'src/app/enums';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared.module';
import { ItemListComponent } from '../shared/item-list/item-list.component';
import { ItemSearchComponent } from '../shared/item-search/item-search.component';

@Component({
  selector: 'app-items',
  templateUrl: './items.component.html',
  styleUrls: ['./items.component.css'],
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule,
    ItemListComponent,
    ItemSearchComponent
  ]
})
export class ItemsComponent implements OnInit {
  step = 0;
  itemsDetails: ItemDetails[] = null;
  public ItemSearchType = ItemSearchType.Items;

  constructor(public globals: Global) { }
  setStep(index: number) {
    this.step = index;
  }
  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
  ngOnInit() {
  }
  receiveItems($event) {
    console.log($event);
    this.itemsDetails = $event;
    this.setStep(1);
  }

}
